import { useActualIncidentId } from '../commonHooks';
import { useQuery } from '@tanstack/react-query';
import { IncidentRoster } from './incidentRoster.types';
import { incidentRosterKeys } from './incidentRoster.queryKeys';
import axios from 'axios';
import config from '../../../../constants/apiConfig';

export const getDraftRosterMembersForIncident = async (
  incidentId: string
): Promise<IncidentRoster> => {
  const response = await axios.get<IncidentRoster>(
    config.apiGateway.getDraftRosterMembersForIncident(incidentId)
  );
  return response.data ?? [];
};

export const useGetDraftRosterMembersForIncident = () => {
  const incidentId = useActualIncidentId();
  return useQuery<IncidentRoster>({
    queryKey: incidentRosterKeys.draftByIncident(incidentId),
    queryFn: async () => getDraftRosterMembersForIncident(incidentId),
    enabled: !!incidentId,
  });
};
